// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-pagination {\n  font-weight: 400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.el-pagination.is-background .btn-next,\n.el-pagination.is-background .btn-prev,\n.el-pagination.is-background .el-pager li {\n  border-radius: 50%;\n}\n.total-count {\n  font-size: 13px;\n  margin-right: 10px;\n}", ""]);
// Exports
module.exports = exports;
